import { DocTitleLink } from './doc-title-link'
import React from 'react'
import { useContext } from './context'

export const DocSidebar = () => {
  const { posts } = useContext()

  return (
    <div className="sidebar">
      <h3 className="sidebar-title">Documents</h3>
      <div className="sidebar-item categories">
        <ul>
          {posts.map((post) => (
            <DocTitleLink key={post.filePath} post={post} />
          ))}
        </ul>
      </div>
    </div>
  )
}
